<div class="person-explorer-entrepreneurship-part">
	<grid-content [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="personExplorer.explorer.customGridHeight()" [rows]="entrepreneurship()"></grid-content>
</div>